import { usePointerScene } from './motion';
import './prospectCard.css';

/* Illustrative profile showing the signals the product records on a lead. */
const SIGNALS = [
  { label: 'SEO health', value: '46%', verdict: 'Weak', tone: 'risk' },
  { label: 'Reviews', value: '68%', verdict: '3.4 stars', tone: 'warn' },
  { label: 'Social presence', value: '24%', verdict: 'Missing', tone: 'risk' },
  { label: 'Website speed', value: '81%', verdict: 'Good', tone: 'good' },
];

export default function ProspectCard3D() {
  const scene = usePointerScene();

  return (
    <div className="prospect-stage" ref={scene.ref} onPointerMove={scene.onPointerMove} onPointerLeave={scene.onPointerLeave}>
      <div className="prospect-scene" aria-hidden="true">
        <div className="prospect-card is-back-2" />
        <div className="prospect-card is-back-1" />
        <div className="prospect-card is-front">
          <header className="prospect-card-head">
            <span className="prospect-avatar">A</span>
            <span className="prospect-identity">
              <strong>Acme Roofing</strong>
              <small>Roofing · Orlando, FL</small>
            </span>
            <span className="prospect-badge">Example</span>
          </header>

          <ul className="prospect-signals">
            {SIGNALS.map((signal, index) => (
              <li key={signal.label} style={{ '--i': index }}>
                <span className="prospect-signal-label">{signal.label}</span>
                <span className="prospect-signal-track">
                  <i className={`is-${signal.tone}`} style={{ '--value': signal.value }} />
                </span>
                <b className={`is-${signal.tone}`}>{signal.verdict}</b>
              </li>
            ))}
          </ul>

          <footer className="prospect-card-foot">
            <span className="prospect-opening">Opening angle</span>
            <p>No social presence and a slow site — lead with visibility.</p>
          </footer>
        </div>
      </div>
    </div>
  );
}
